import Vue from 'vue';
import { encodePathSegment } from '@/utils/url';

const success = response => response;

const error = () => {};

export default user => Vue.$http
    .delete(`users/${encodePathSegment(user.id)}`)
    .then(success)
    .catch(error);



// WEBPACK FOOTER //
// ./src/services/user/del.js